export default __webpack_public_path__ + "static/media/pic1.a2c74b0d.svg";